import React, { createContext, useEffect, useState } from 'react';
import { fetchWrapper } from '../../shared/api/fetchWrapper';

// PanelContext oluşturuyoruz
export const PanelContext = createContext();

export const PanelProvider = ({ children }) => {
  const [selectedPanel, setSelectedPanel] = useState('flow');
   
  return (
    <PanelContext.Provider value={{ selectedPanel, setSelectedPanel }}>
      {children}
    </PanelContext.Provider>
  );
};
